<template>
	<div id="app">
		<router-view />
		<!-- Modal Overlay -->
	</div>
</template>
<script>
export default {
	data() {
		return {
			orderNo: '',
			inputvalue: '',
			dialogVisible: false,
		};
	},

	methods: {},
};
</script>
<style lang="scss">
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
	// margin: 0;
	// padding: 0;
	// box-sizing: border-box;
	// font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
	// line-height: 1.6;
}

nav {
	padding: 30px;

	a {
		font-weight: bold;
		color: #2c3e50;

		&.router-link-exact-active {
			color: #42b983;
		}
	}
}

/* Overlay with blur effect */
// .modal-overlay {
//   position: fixed;
//   top: 0;
//   left: 0;
//   right: 0;
//   bottom: 0;
//   background-color: rgba(0, 0, 0, 0.5);
//   backdrop-filter: blur(8px);
//   -webkit-backdrop-filter: blur(8px);
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   z-index: 1000;
//   animation: fadeIn 0.3s ease;
// }

// @keyframes fadeIn {
//   from {
//     opacity: 0;
//   }

//   to {
//     opacity: 1;
//   }
// }

/* Modal container */
.el-dialog {
	background: white;
	border-radius: 20px;
	padding: 10px 40px 40px 40px;
	width: 520px;
	max-width: 520px;
	box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
	// animation: slideUp 0.4s ease;
	position: relative;
}

@keyframes slideUp {
	// from {
	//   opacity: 0;
	//   transform: translateY(30px);
	// }

	// to {
	//   opacity: 1;
	//   transform: translateY(0);
	// }
}

/* Modal header */
.modal-header {
	text-align: center;
	margin-bottom: 32px;
}

.modal-title {
	font-size: 24px;
	font-weight: 600;
	color: #1a1a1a;
	margin-bottom: 8px;
}

.modal-subtitle {
	font-size: 16px;
	color: #666;
}

/* Form styling */
.form-group {
	margin-bottom: 24px;
}

.form-label {
	display: block;
	font-size: 14px;
	font-weight: 500;
	color: #1a1a1a;
	margin-bottom: 8px;
}

.form-input {
	width: 90%;
	padding: 14px 20px;
	border: 2px solid #e1e1e1;
	border-radius: 12px;
	font-size: 16px;
	color: #1a1a1a;
	background-color: #f8f8f8;
	transition: all 0.3s ease;
	outline: none;
}

.form-input:focus {
	border-color: #5865f2;
	background-color: white;
	box-shadow: 0 0 0 4px rgba(88, 101, 242, 0.1);
}

.form-input::placeholder {
	color: #999;
}

/* Submit button */
.submit-btn {
	width: 100%;
	padding: 14px 32px;
	background-color: #5865f2;
	color: white;
	border: none;
	border-radius: 12px;
	font-size: 16px;
	font-weight: 600;
	cursor: pointer;
	transition: all 0.3s ease;
	box-shadow: 0 4px 12px rgba(88, 101, 242, 0.3);
}

.submit-btn:hover {
	background-color: #4752c4;
	transform: translateY(-2px);
	box-shadow: 0 6px 20px rgba(88, 101, 242, 0.4);
}

.submit-btn:active {
	transform: translateY(0);
}

/* Help text */
.help-text {
	text-align: center;
	margin-top: 20px;
	font-size: 14px;
	color: #666;
}

.help-link {
	color: #5865f2;
	text-decoration: none;
	font-weight: 500;
}

.help-link:hover {
	text-decoration: underline;
}

/* Lock icon */
.lock-icon {
	width: 60px;
	height: 60px;
	margin: 0 auto 24px;
	background-color: #f3f0ff;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 28px;
}

/* Close button (optional) */
.close-btn {
	position: absolute;
	top: 20px;
	right: 20px;
	width: 32px;
	height: 32px;
	border: none;
	background-color: #f3f0ff;
	border-radius: 50%;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: all 0.3s ease;
	color: #666;
	font-size: 18px;
}

.close-btn:hover {
	background-color: #e1e1e1;
	transform: rotate(90deg);
}

/* Error state */
.form-input.error {
	border-color: #ef4444;
}

.error-message {
	color: #ef4444;
	font-size: 14px;
	margin-top: 8px;
	display: none;
}

.error-message.show {
	display: block;
}

/* Loading state */
.submit-btn.loading {
	background-color: #999;
	cursor: not-allowed;
}

.spinner {
	display: inline-block;
	width: 16px;
	height: 16px;
	border: 2px solid #f3f4f6;
	border-top-color: white;
	border-radius: 50%;
	animation: spin 1s linear infinite;
	margin-right: 8px;
	vertical-align: middle;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

.el-dialog__wrapper {
	background-color: rgba(0, 0, 0, 0.5);
	backdrop-filter: blur(8px);
	-webkit-backdrop-filter: blur(8px);
	/* 修改遮罩层颜色和透明度 */
}
</style>
